import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environment';
import { ReportSummary } from '@models/report-summary';
import { Observable, of } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class ReportService {
    private baseReportUrl: string = environment.ApiBase + 'reports/';

    constructor(private _http: HttpClient) {}

    getReportAccess(reportId: string): Observable<string> {
        let params: HttpParams = new HttpParams();
        params = params.append('reportId', reportId);
        return this._http.get<string>(this.baseReportUrl + 'access', { params: params });
    }

    getReportList(id: string = ''): Observable<ReportSummary[]> {
        let params: HttpParams = new HttpParams();
        params = params.append('reportId', id);

        return this._http.get<ReportSummary[]>(`${this.baseReportUrl}list`, { params: params });
    }

}
